module.exports = __webpack_public_path__ + "img/9.74ff68f5.png";